import { ReactNode, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { ConditionalRule } from '../validations/validations';

import { evaluateCondition } from './conditionalUtils';

interface ConditionalFieldWrapperProps {
  conditional: ConditionalRule;
  fieldName: string;
  children: ReactNode;
}

export default function ConditionalFieldWrapper({
  conditional,
  fieldName,
  children,
}: ConditionalFieldWrapperProps) {
  const { watch, unregister } = useFormContext();
  const parentValue = watch(conditional.field);
  const isVisible = evaluateCondition(conditional, parentValue);

  useEffect(() => {
    if (!isVisible) {
      unregister(fieldName);
    }
  }, [isVisible, fieldName, unregister]);

  if (!isVisible) return null;

  return <>{children}</>;
}
